import { render, staticRenderFns } from "./DestinationAddressSearchBox.vue?vue&type=template&id=78e52168&"
import script from "./DestinationAddressSearchBox.vue?vue&type=script&lang=js&"
export * from "./DestinationAddressSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports